import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { filter, length } from "@pdfking/rfunc"
import { KeyDrop, RecordMerge } from "@pdfking/tfunc"
import { Icon } from "@pdfking/workflow/components/Icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import { CloseMixin } from "../../../mixins/Close"
import state from "../../../state/main"

export const Results = CreateRenderFunction({
  computed: {
    translations: () => make_translations("actions"),
  },
  data: {
    expanded: {} as Record<string, boolean>,
    expandSize: 6,
    selected: {} as Record<string, any>,
  },
  methods: {
    is_expanded(id: string) {
      return this.expanded[id]
    },
    length,
    toggle_expanded(id: string) {
      this.expanded = RecordMerge(this.expanded, { [id]: !this.expanded[id] })

      if (this.expanded[id]) {
        state().track_event("menu_expand", "menu")
      }
    },
    truncate_links(page: any) {
      if (this.is_expanded(page.id)) {
        return page.descendants
      }

      return filter(
        (_page: any, index: number) => index < this.expandSize,
        page.descendants
      )
    },
  },
  mixins: [CloseMixin],
  props: {
    pages: [] as Record<string, any>[],
  },
  render() {
    if (length(this.pages) == 0) {
      return (
        <div class="display-5 mt-4">{this.translations.actions.NO_RESULTS}</div>
      )
    }

    return (
      <div class="row pt-4">
        {(this.pages as any[]).map((page: any) => (
          <div
            class="col col-6 col-lg-4"
            key={page.id}
            style={{ order: page.kind_sequence }}
          >
            <div class="megamenu-section row-space markdown-compact">
              {(this.selected[page.id] || page.img) && (
                <a
                  class="megamenu-preview rounded"
                  data-track-event="menu_link"
                  data-track-type="menu"
                  href={page.url}
                  onClick={this.close}
                  style={{
                    "background-image":
                      "url(" +
                      (this.selected[page.id]
                        ? this.selected[page.id].img
                        : page.img) +
                      ")",
                  }}
                  title={page.unicode}
                />
              )}
              <a
                class="h6"
                data-track-event="menu_link"
                data-track-type="menu"
                href={page.url}
                onClick={this.close}
                title={page.unicode}
              >
                {page.icon && <Icon name={page.icon} />}
                {page.unicode}
              </a>
              {length(page.descendants) == 0 ? (
                <p
                  class="small markdown"
                  dangerouslySetInnerHTML={{ __html: page.description }}
                ></p>
              ) : (
                <div class="d-flex flex-column">
                  {this.truncate_links(page).map((sub: any) => (
                    <a
                      class="megamenu-link"
                      data-track-event="menu_link"
                      data-track-type="menu"
                      href={sub.url}
                      key={sub.id}
                      onClick={this.close}
                      onMouseOut={() => {
                        this.selected = KeyDrop(this.selected, [page.id])
                      }}
                      onMouseOver={() => {
                        this.selected = RecordMerge(this.selected, {
                          [page.id]: sub,
                        })
                      }}
                      style={{ order: sub.kind_sequence }}
                      title={sub.unicode}
                    >
                      {sub.unicode}
                    </a>
                  ))}
                </div>
              )}
              {length(page.descendants) > this.expandSize && (
                <a
                  class="megamenu-expand"
                  href="#"
                  onClick={(e: Event) => {
                    e.preventDefault()
                    this.toggle_expanded(page.id)
                  }}
                >
                  {this.is_expanded(page.id)
                    ? this.translations.actions.HIDE
                    : this.translations.actions.SHOW_ALL +
                      " (" +
                      length(page.descendants) +
                      ")"}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    )
  },
})
